import config from "../../../helper/config";
import APIHandler from "../../../handlers/APIHandler";

export const authorTypeService = {
    getAll,
    getAllAuthorTypes,
    addAuthorType,
    updateAuthorType,
    deleteAuthorType,
};

async function getAll(limit, offset, search_term, sort_column, sort_direction) {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };
    
    const response = await fetch(
        `${config.oat_api_url}/manage/author-types/getAllAuthorTypes/?limit=${limit}&offset=${offset}&search_term=${search_term}&sort_column=${sort_column}&sort_direction=${sort_direction}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function getAllAuthorTypes() {
    const configOptions = {
        method: "GET",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/author-types/getAll/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function addAuthorType(newAuthorType) {
    const configOptions = {
        method: "POST",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(newAuthorType),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/author-types/add/`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function updateAuthorType(authorTypeItem, authorTypeId) {
    const configOptions = {
        method: "PUT",
        headers: APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        body: JSON.stringify(authorTypeItem),
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/author-types/update/${authorTypeId}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}

async function deleteAuthorType(id) {
    const configOptions = {
        method: "DELETE",
        headers: {
        ...APIHandler.getHeader(config.azure_ad_config.apis.OAT.name),
        "Content-Type": "application/json",
        },
    };

    const response = await fetch(
        `${config.oat_api_url}/manage/author-types/delete/${id}`,
        configOptions
    );
    return APIHandler.handleResponse(response);
}
